/**
 * Tasdiqlash oynasi: `if (await confirmDialog({...})) ...` -- true/false qaytaradi.
 * Xavfli amallar (arxivlash, bloklash, rad etish) uchun; bitta host main.tsx da (Toaster yonida).
 */
import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./button";
import { Modal } from "./modal";

export interface ConfirmOptions {
  title: string;
  description?: string;
  confirmLabel?: string;
  danger?: boolean;
}

type Pending = ConfirmOptions & { resolve: (ok: boolean) => void };

let current: Pending | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function confirmDialog(options: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    current?.resolve(false); // oldingisi javobsiz qolgan bo'lsa -- bekor
    current = { ...options, resolve };
    emit();
  });
}

function settle(ok: boolean) {
  const pending = current;
  current = null;
  emit();
  pending?.resolve(ok);
}

export function ConfirmHost() {
  const { t } = useTranslation();
  const state = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
  return (
    <Modal
      open={!!state}
      onOpenChange={(open) => !open && settle(false)}
      size="sm"
      title={state?.title ?? ""}
      footer={
        <>
          <Button onClick={() => settle(false)}>{t("actions.cancel")}</Button>
          <Button variant={state?.danger ? "danger" : "primary"} onClick={() => settle(true)} autoFocus>
            {state?.confirmLabel ?? t("actions.confirm")}
          </Button>
        </>
      }
    >
      {state?.description ? <p className="text-[13px] text-ink-soft">{state.description}</p> : null}
    </Modal>
  );
}
